import {KpSvelteComponentWrapperComponent} from 'src/core';
import type {StateProvider} from '@uirouter/angularjs';

/*@ngInject*/
export function reportApprovingRoutes($stateProvider: StateProvider) {
    let reportApprovingModule: {default: any;};

    if (window.portaroConfiguration.isSutorSutinLayout) {
        $stateProvider
            .state({
                name: 'reports-approving',
                url: '/reports/approving',
                component: KpSvelteComponentWrapperComponent.componentName,
                resolve: {
                    component: () => reportApprovingModule.default
                },
                lazyLoad: async () => {
                    reportApprovingModule = await import(/* webpackChunkName: "reportApprovingPage" */ './ReportApprovingPage.svelte');
                    return null;
                }
            });
    }
}